// Função que converte metadata para metadataValues garantindo que todos os valores sejam arrays
export function convertMetadataToMetadataValues(metadata: any): { [key: string]: string[] } {
  if (!metadata || Object.keys(metadata).length === 0) {
    return null;
  }

  const metadataValues: { [key: string]: string[] } = {};

  for (const key in metadata) {
    const value = metadata[key];
    
    // Ignora valores nulos, undefined ou arrays vazios
    if (value === null || value === undefined) {
      continue;
    }
    
    // Se for um array não vazio, usa diretamente
    if (Array.isArray(value)) {
      if (value.length > 0) {
        metadataValues[key] = value;
      }
    }
    // Se for um valor único, converte para array
    else {
      metadataValues[key] = [value];
    }
  }

  return Object.keys(metadataValues).length > 0 ? metadataValues : null;
}

